export default __webpack_public_path__ + "static/media/bukopin-mobile.ebd84311.png";